import Search from './Search.js';

const initSearch = () => {
  const elements = Array.from(document.querySelectorAll('[data-component="search"]'));

  elements.forEach((element) => {
    new Search(element);
  });
};

export default initSearch;
